module.exports = __webpack_public_path__ + "img/BfA_her.3307be03.png";